import { render, staticRenderFns } from "./userDataDialog.vue?vue&type=template&id=437b3af9&scoped=true&"
import script from "./userDataDialog.vue?vue&type=script&lang=js&"
export * from "./userDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./userDataDialog.vue?vue&type=style&index=0&id=437b3af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b3af9",
  null
  
)

export default component.exports